import { z } from "zod/v4";

/**
 * Validation schema for the admin "change expiry date" dialog.
 *
 * `expiresAt` is a full ISO 8601 UTC datetime — what the `DatePicker`
 * emits (`Date.toISOString()`) and what `PUT /api/v1/admin/resources/{id}/expiry`
 * expects. A past instant is allowed on purpose: it is how an operator
 * hands a resource to the expiry suspension scan.
 */
export const resourceExpirySchema = z.object({
  expiresAt: z
    .string()
    .min(1, "Expiry date is required")
    .refine(
      (value) => !Number.isNaN(new Date(value).getTime()),
      "Expiry date must be a valid date",
    ),

  /**
   * Optional: the change goes through without one, and the audit row then says so in its own
   * words. It reaches no column on the resource — the audit trail is the only place it survives,
   * which is why the backend caps it at 500 characters before copying it into the description.
   */
  reason: z
    .string()
    .max(500, "Reason cannot exceed 500 characters")
    .optional(),
});

export type ResourceExpiryFormData = z.infer<typeof resourceExpirySchema>;
